import cryptoRandomString from 'crypto-random-string';

/**
 * Generates a random hexadecimal color with 100% alpha transparency in the format #RRGGBBFF.
 *
 * @returns {string} The randomly generated hexadecimal color.
 */
const generateHexColor = () => {
  const color = cryptoRandomString({ length: 6, type: 'hex' });
  return `#${color}ff`;
};

export default generateHexColor;
